import { render, staticRenderFns } from "./PRJ401P01.vue?vue&type=template&id=5d0fcc4c&"
import script from "./PRJ401P01.vue?vue&type=script&lang=js&"
export * from "./PRJ401P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports